import React from "react";
import MedmateLinkingPanel from "@/components/admin/medmate/MedmateLinkingPanel";

export default function MedmateLinkingPage() {
  return (
    // fill the outlet area, scroll if content overflows
    <div className="h-full overflow-y-auto">
      <div className="p-5 max-w-5xl mx-auto">
        <h2 className="text-lg font-bold text-slate-800 mb-1">Medmate Linking</h2>
        <p className="text-sm text-slate-500 mb-5">
          Search for a pharmacy, enter or update its Medmate Provider ID, then click Match.
        </p>
        <MedmateLinkingPanel />
      </div>
    </div>
  );
}
